import React from 'react';
import { useNavigate } from 'react-router-dom';


const EventCards = () => {

  const navigate = useNavigate();

  const events = [
    {
      id: 1,
      image: "assets/images/banner1.jpg",
      alt: "Group collaborating in office",
      time: "7:00 pm - 9:00 pm",
      date: { day: "18", month: "Dec" },
      title: "Creative Teaching Seminar Master Class",
      description: "Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore…",
      location: "Ontario City, Canada"
    },
    {
      id: 2,
      image: "assets/images/banner1.jpg",
      alt: "Woman with makeup products",
      time: "6:00 pm - 9:00 pm",
      date: { day: "28", month: "Dec" },
      title: "Digital Arts & Reshaping the Future with AI",
      description: "Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore…",
      location: "Newyork City, USA"
    },
    {
      id: 3,
      image: "assets/images/banner2.jpg",
      alt: "Man giving presentation",
      time: "11:00 am - 1:00 pm",
      date: { day: "10", month: "Dec" },
      title: "Online Presentation on PowerPoint 2024",
      description: "Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore…",
      location: "Ontario City, Canada"
    },
    {
      id: 4,
      image: "assets/images/banner3.jpg",
      alt: "Colleagues collaborating",
      time: "2:00 pm - 4:00 pm",
      date: { day: "21", month: "Nov" },
      title: "Workshop on Team Collaboration",
      description: "Learn effective teamwork skills to enhance your project success and communication.…",
      location: "San Francisco, USA"
    },
    {
      id: 5,
      image: "assets/images/banner4.jpg",
      alt: "Woman working on AI",
      time: "3:30 pm - 5:00 pm",
      date: { day: "30", month: "Nov" },
      title: "AI & Future Technology Trends",
      description: "Discover the emerging trends in artificial intelligence shaping the future of technology.…",
      location: "Boston, USA"
    },
    {
      id: 6,
      image: "assets/images/banner5.jpg",
      alt: "Man giving virtual workshop",
      time: "9:00 am - 11:00 am",
      date: { day: "05", month: "Dec" },
      title: "Virtual Workshop on Digital Skills",
      description: "Enhance your digital skills and teamwork capabilities with this engaging virtual workshop.…",
      location: "Toronto, Canada"
    }
  ];

  const handleCardClick = (eventId) => {
    navigate(`/events/${eventId}`);
  };

  return (
    <div className="container py-5">
      <div className="d-flex justify-content-center align-items-center text-center flex-column mx-auto " data-aos="fade-up">
      <h2 className="mb-4 mt-2 mt-0" style={{color:"#200D46"}}>Latest News & Updates</h2>

              </div>
      <div className="row g-4 p-2">
        {events.map(event => (
          <div key={event.id} className="col-lg-4 col-md-6 col-sm-12" data-aos="fade-up"  data-aos-delay={`${event.id * 200}`}
          data-aos-duration="800">

            <div className="card  h-100 position-relative border-0  shadow-sm"  onClick={() => handleCardClick(event.id)}
              style={{ cursor: 'pointer' }}>
              <div className="position-relative">
                <img 
                  src={event.image} 
                  alt={event.alt} 
                  className="card-img-top w-100 object-fit-cover" 
                  style={{ height: '200px' }}
                />
                <div className="position-absolute top-0 start-0 bg-warning text-dark px-3 py-1 rounded-end z-1">
    <i className="bi bi-clock me-1"></i>
    {event.time}
  </div>


  

  {/* Card Body */}
  <div className="card-body pt-4 px-3 pb-3">
    <h5 className="card-title fw-semibold mb-2 fs-md-5 hover-orange">{event.title}</h5>
    <p className="card-text text-muted small mb-3 line-clamp-2" style={{ WebkitLineClamp: 2 }}>
      {event.description}
    </p>
    <div className="d-flex align-items-center text-primary">
      <i className="bi bi-geo-alt-fill me-2"></i>
      <span className="small fw-medium">{event.location}</span>
    </div>
  </div>
</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventCards;